<template>
  <div class="cart_title">
    <van-nav-bar title="购物车" />
  </div>
  <div class="cart_content" v-if="Carts.Items.length > 0">
    <div class="cart_items">
      <div v-for="(item, index) in Carts.Items" :key="index">
        <div class="cart_item">
          <div class="item_opt">
            <van-button
              icon="minus"
              type="primary"
              size="mini"
              @click="MinusCartItem(item)"
            />
          </div>
          <div class="item_detail">
            {{ item.Count }} ✖ {{ item.ProductItem.Name }}
          </div>
          <div class="item_detail_btn">
            <van-icon name="label-o" @click="DetailOrder(item)" />
          </div>
          <div class="item_amount">
            {{ item.SubtotalFormat }}
          </div>
        </div>
        <div
          class="cart_items_gengduo"
          v-if="item.ProductType == 200"
          @click="CollectionItemDetail(item)"
        >
          <span> 套餐 </span>
          <van-icon name="notes-o" class="icon" />
        </div>
      </div>
    </div>

    <!-- 详细信息 -->
    <div class="cart_total_content" v-if="Carts.Items.length > 0">
      <div class="cart_total_title" v-if="UserInfo.AccountType == 100">
        <div>桌台</div>
        <div>{{ UserInfo.Name }}</div>
      </div>

      <div class="cart_total_title">
        <div>合计</div>
        <div>{{ Carts.TotalFormat }}</div>
      </div>
      <div class="cart_total_tax">
        <div>税额</div>
        <div>{{ Carts.TaxAmountFormat }}</div>
      </div>
      <div class="cart_total_amount">
        <div>金额</div>
        <div>{{ Carts.AmountFormat }}</div>
      </div>
      <div class="cart_plan_order">
        <van-button round type="primary" block @click="PlaceAnOrder()"
          >下单</van-button
        >
      </div>
    </div>
  </div>

  <!-- 支付页面 -->
  <van-action-sheet v-model:show="PlaceOrder" title="支付">
    <div class="content">
      <div class="content_item">
        <div class="content_item_title">
          <span> 地址 </span>
          <router-link class="manage" to="addresslist">
            <van-icon name="add-o" />
          </router-link>
        </div>
        <addressfield v-model="AddressId" />
      </div>
      <div>
        <div class="content_item">
          <div class="content_item_title">
            <span> 支付方式 </span>
          </div>
          <paymethods v-model="PaymenthodId" />
        </div>
      </div>
      <div>
        <div class="content_item">
          <div class="content_item_title">
            <span> 货运方式 </span>
          </div>
          <freightTransport v-model="FreightTransportId" />
        </div>
      </div>
      <div>
        <van-divider content-position="left" dashed>备注</van-divider>
        <van-cell-group inset>
          <van-field
            v-model="Remarks"
            rows="1"
            autosize
            label="留备注言"
            type="textarea"
            placeholder="请输入备注"
          />
        </van-cell-group>
      </div>

      <br />
      <br />
      <br />
      <van-button round type="primary" block @click="PayOrder()"
        >支付</van-button
      >
    </div>
  </van-action-sheet>

  <!-- 详细信息 -->
  <van-action-sheet v-model:show="DetailOrderWindow" title="详细信息">
    <!-- <div class="detail_attributes_content">
      <div class="detail_attributes_items">
        <div
          class="detail_attributes_name"
          v-for="item in CartItemOpt.AttributesOpt"
          :key="item.Id"
        >
          1 * {{ item.Name }} {{ item.PriceFormat }}
        </div>
      </div>
      <div class="detail_params_items">
        <div
          class="detail_params_name"
          v-for="item in CartItemOpt.OptProductRemarkItems"
          :key="item.Id"
        >
          1 * {{ item.Name }} {{ item.PriceFormat }}
        </div>
      </div> 
    </div> -->
    <AttributeParamsMoudule :Model="CartItemOpt" />
  </van-action-sheet>

  <!-- 空购物车提示 -->
  <div class="cart_tips" v-if="Carts.Items.length == 0">
    <p>
      <svg
        t="1659185225274"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="3480"
        width="200"
        height="200"
      >
        <path
          d="M734.208 354.461538a78.769231 78.769231 0 0 1 73.216 49.703385L866.461538 552.881231V787.692308a78.769231 78.769231 0 0 1-78.76923 78.76923H236.307692a78.769231 78.769231 0 0 1-78.76923-78.76923v-231.699693l59.195076-151.433846A78.769231 78.769231 0 0 1 290.107077 354.461538h444.100923z m-355.209846 212.676924H189.046154L189.046154 787.692308a47.261538 47.261538 0 0 0 42.417231 47.02523L236.307692 834.953846h551.384616a47.261538 47.261538 0 0 0 47.02523-42.417231L834.953846 787.692308v-220.553846h-189.952a133.907692 133.907692 0 0 1-266.003692 0z m355.249231-181.169231H290.067692a47.261538 47.261538 0 0 0-41.865846 25.284923l-2.166154 4.765538L199.286154 535.630769h190.306461l-0.039384 0.590769A15.753846 15.753846 0 0 1 409.6 551.384615a102.4 102.4 0 0 0 204.8 0 15.753846 15.753846 0 0 1 14.848-15.753846h196.450462l-47.576616-119.847384a47.261538 47.261538 0 0 0-38.675692-29.538462l-5.238154-0.275692zM286.168615 106.417231l2.166154 2.363077 114.609231 155.254154a15.753846 15.753846 0 0 1-23.158154 21.070769l-2.166154-2.363077-114.60923-155.214769a15.753846 15.753846 0 0 1 23.158153-21.110154z m244.460308-4.017231a15.753846 15.753846 0 0 1 15.438769 12.603077l0.315077 3.150769v155.254154a15.753846 15.753846 0 0 1-31.192615 3.150769l-0.315077-3.150769V118.153846c0-8.664615 7.049846-15.753846 15.753846-15.753846z m265.688615 3.072a15.753846 15.753846 0 0 1 4.962462 19.298462l-1.614769 2.756923-114.333539 155.175384a15.753846 15.753846 0 0 1-26.978461-15.911384l1.575384-2.756923 114.372923-155.21477a15.753846 15.753846 0 0 1 22.016-3.347692z"
          fill="#dbdbdb"
          p-id="3481"
        ></path>
      </svg>
    </p>
    <p>您的购物车是空的</p>
  </div>

  <!-- 套餐信息 -->
  <van-action-sheet v-model:show="CollectionDetailWindow" title="套餐信息">
    <cartCollectionItem
      :Model="CartItemOpt"
      @GetShoppingCart="GetShoppingCartComplete"
    />
  </van-action-sheet>
  <br />
  <br />
  <br />
  <br />

  <tabbar :active="2" />
</template> 
<script >
import tabbar from "../../components/tabbars/tabbar.vue";
import addressfield from "../../components/addressfield.vue";
import paymethods from "../../components/pay-methods.vue";
import freightTransport from "../../components/freightTransport.vue";
import AttributeParamsMoudule from "../../components/AttributeParamsMoudule.vue";
import cartCollectionItem from "../../components/cartCollectionItem.vue";

import axios from "../../commons/AxiosMethod.js";
import commons from "../../commons/commons.js";
import { Toast } from "vant";

export default {
  data() {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      Carts: {
        Items: [],
      }, //购物车项目
      PlaceOrder: false,
      PaymenthodId: "", //选中支付方式
      AddressId: "", //选中支付地址
      FreightTransportId: "", //货运地址
      Remarks: "",

      DetailOrderWindow: false, //详细信息页面
      CartItemOpt: {}, //选中购物车项目

      UserInfo: {}, //用户信息

      CollectionDetailWindow: false, //套餐详细页面
    };
  },
  name: "App",
  mounted() {
    this.GetShoppingCartComplete();
    this.GetUserInfo();
  },
  components: {
    tabbar,
    addressfield,
    paymethods,
    freightTransport,
    AttributeParamsMoudule,
    cartCollectionItem,
  },
  methods: {
    //查看套餐详细信息
    CollectionItemDetail(item) {
      this.CartItemOpt = item;
      this.CollectionDetailWindow = true;
    },
    //详细信息
    DetailOrder(item) {
      this.CartItemOpt = item;
      this.DetailOrderWindow = true;
    },
    //减少商品
    MinusCartItem(item) {
      axios.apiMethod(
        "/Shopping/ShoppingTrolley/MinusCartItem",
        "get",
        { Id: item.Id },
        (result) => {
          if (result.Code == 200) {
            if (result.Data) {
              this.GetShoppingCartComplete();
            }
          }
          Toast(result.Msg);
        },
        (e) => {}
      );
    },
    //下单
    PayOrder() {
      axios.apiMethod(
        "/Orders/Order/PlaceOrder?PayMethodId=" +
          this.PaymenthodId +
          "&FreightTransportId=" +
          this.FreightTransportId +
          "&AddressId=" +
          this.AddressId,
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            this.$router.push({
              name: "sysred",
              query: { Id: result.Data },
            });
          } else {
            Toast(result.Msg);
          }
        },
        (e) => {}
      );
    },
    PlaceAnOrder() {
      this.PlaceOrder = true;
    },
    // 获取购物车
    GetShoppingCartComplete() {
      axios.apiMethod(
        "/Shopping/ShoppingTrolley/GetShoppingCartComplete",
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            this.Carts = result.Data;
          } else {
            Toast(result.Msg);
          }
        },
        (e) => {}
      );
    },

    //获取用户信息
    GetUserInfo() {
      var param = {};
      axios.apiMethod("/api/User/GetUserInfo", "get", param, (result) => {
        if (result.Code == 200) {
          this.UserInfo = result.Data;
        }
      });
    },
  },
};
</script>
 
 
<style lang="scss" scoped>
.cart_title {
  position: fixed;
  width: 100%;
  height: 40px;
  z-index: 50000000;
}
.cart_content {
  padding: 10px;

  .cart_items {
    background-color: #fff;
    margin: 0 auto;
    margin-top: 40px;
    overflow: auto;
    .cart_item {
      border-bottom: 1px solid #eee;
      margin-top: 5px;
      height: 50px;
      line-height: 50px;
      width: calc(100% - 30px);
      padding: 0px 5px;
      display: flex;
      justify-content: space-between;

      .item_opt {
        width: 40px;
        height: 40px;
        line-height: 40px;
      }

      .item_detail {
        width: calc(100% - 140px);
        font-size: 9pt;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
        font-family: Avenir, Helvetica, Arial, sans-serif;
      }
      .item_amount {
        width: 100px;
        text-align: right;
        font-size: 11pt;
      }
    }
    .cart_items_gengduo {
      padding: 5px;
      font-size: 9pt;
      float: right;
      margin-right: 30px;
      .icon {
        font-size: 17pt !important;
      }
    }
  }

  .cart_total_content {
    max-width: 100%;
    background-color: #fff;
    margin-top: 15px;
    padding: 15px;
    .cart_total_title,
    .cart_total_tax,
    .cart_total_amount {
      border-bottom: 1px solid #eee;
      padding: 8px 20px;
      display: flex;
      justify-content: space-between;
    }
    .cart_plan_order {
      margin-top: 30px;
    }
  }
}
.detail_attributes_content {
  min-height: 300px;
  .detail_attributes_items,
  .detail_params_items {
    width: calc(100% - 50px);
    margin: 0 auto;
    padding: 5px 0px;
    border-radius: 5px;
    border: 1px solid #eee;
    .detail_attributes_name,
    .detail_params_name {
      width: calc(100% - 100px);
      margin-left: 5px;
      font-size: 9pt;
    }
  }
  .detail_params_items {
    margin-top: 10px;
  }
}

.content {
  min-height: 300px;
  .content_item {
    .content_item_title {
      width: calc(100% - 100px);
      margin-left: 20px;
      font-size: 15pt;
      .manage {
        font-size: 15pt;
        color: #666;
        float: right;
      }
    }
  }
}

.cart_tips {
  position: fixed;
  top: 200px;
  width: 100%;
  text-align: center;
  .cart_tips_icon {
    font-size: 17pt;
  }
}
</style>
